module.exports = __webpack_public_path__ + "assets/93ad1b7b014ef599d3bf3d0fe307f912.mp3";